import React, { Fragment, useMemo } from "react";
import Grid from "@mui/material/Grid";
import ItemRow from "./ItemRow";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Checkbox, Divider, FormControlLabel } from "@mui/material";
import _ from "lodash";
import { FnDialog, I18n } from "utilities/utilities";
import { I18NextNs } from "enum/enum";
import { BtnDelete } from "components/Button/ButtonAll";

const DisplayListRow = (props: any) => {

  const {
    IsCrop,
    cropShape,
    cropRatio,
    cropResize,
    cropMovable,
    IsHide = false
  } = props;

  const DialogFn = FnDialog();
  const [selected, setSelected] = React.useState<readonly string[]>([]);

  const newArrFile = useMemo(() => {
    let arr = [] as any;
    if (props.arrFile) {
      arr = Array.from(props.arrFile);
      props.setClearImport && props.setClearImport(false);
    } else {
      if (props.isClearImport) {
        onHandleDelete();
      }
    }
    return arr;
  }, [props.arrFile])

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(newArrFile);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    props.SetarrFile(items);
  };

  const onHandleDelete = () => {
    DialogFn.Submit(
      I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent)
      , () => {
        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent));
        DialogFn.CloseSubmit()
        DialogFn.UnBlockUI();
        let arrNew = _.filter(newArrFile, (item) => {
          return !selected.includes(item.sFile_ID);
        });
        //Delete File un-used
        selected.forEach(sFile_ID => {
          props.onDeleteFileInLocation(sFile_ID)
        });
        props.SetarrFile(arrNew);
      }
    )
  }

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = newArrFile.map((n) => n.sFile_ID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (sFile_ID: string) => {
    const selectedIndex = selected.indexOf(sFile_ID);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, sFile_ID);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (sFile_ID: string) => selected.indexOf(sFile_ID) !== -1;

  return (
    <Fragment>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
      >
        {props.IsMultiDelete && !IsHide &&
          <Grid item xs={12}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item >
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      indeterminate={selected.length > 0 && selected.length < newArrFile.length}
                      checked={newArrFile.length > 0 && selected.length === newArrFile.length}
                      onChange={handleSelectAllClick}
                    />
                  }
                  label="Check All"
                  style={{ marginLeft: '12px' }}
                />
              </Grid>
              <Grid item >
                {
                  selected.length > 0 ?
                    <BtnDelete id={"delete-onTable"} txt="ลบ" onClick={onHandleDelete} />
                    : null
                }
              </Grid>
            </Grid>
          </Grid>
        }
        <Grid item xs={12} style={{ padding: "0 8px" }}>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="lstFile">
              {(provided) => (
                <ul
                  className={"mui-style-lstFile"}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {newArrFile.map((f, i) => {
                    let sKey = f.sFile_ID + "";
                    let sKeyItem = f.sFile_ID + i;
                    return (
                      <Draggable
                        key={sKey}
                        draggableId={sKey}
                        index={i}
                        isDragDisabled={!props.IsDrag || props.disabled}
                      >
                        {(provided) => (
                          <li
                            // style={{ padding: '4px 0px' }}
                            style={{ backgroundColor: "yellow" }}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <ItemRow
                              key={sKeyItem}
                              IsopenPopUp={props.IsopenPopUp}
                              setIsopenPopUp={props.setIsopenPopUp}
                              IsCrop={IsCrop}
                              cropShape={cropShape}
                              cropRatio={cropRatio}
                              cropResize={cropResize}
                              cropMovable={cropMovable}
                              arrObjFile={props.arrObjFile}
                              sFileType={f.sFileType}
                              sFileName={f.sFileName}
                              sPath={f.sPath}
                              sSize={f.sSizeName}
                              IsCompleted={f.IsCompleted}
                              IsProgress={f.IsProgress}
                              sProgress={f.sProgress}
                              sFolderName={f.sFolderName}
                              onDelete={props.onDelete}
                              sFile_ID={f.sFile_ID}
                              sUrl={f.sUrl}
                              sCropFileLink={f.sCropFileLink}
                              sFileLink={f.sFileLink}
                              disabled={props.disabled}
                              onOpenFile={props.onOpenFile}
                              IsHiddenUploadBox={props.IsHiddenUploadBox}
                              setStartVideoOn={props.setStartVideoOn}
                              nStartVideoOn={props.nStartVideoOn}
                              CannotSkipForward={props.CannotSkipForward}
                              onVideoEnd={props.onVideoEnd}
                              onDeleteFileInLocation={props.onDeleteFileInLocation}
                              SendCropImage={props.SendCropImage}
                              //Delete multi
                              IsMultiDelete={props.IsMultiDelete}
                              handleSelectAllClick={handleSelectAllClick}
                              handleClick={handleClick}
                              isSelected={isSelected}
                              onHandleDelete={onHandleDelete}
                              sPopup={props.sPopup}
                              IsHide={IsHide}
                            />
                            <hr style={{ margin: '0', borderColor: '#ebeef1', opacity: 0.4 }} />
                            {/* {newArrFile.length > 1 && <hr style={{ margin: '0', borderColor: '#ebeef1', opacity: 0.4 }} />} */}
                          </li>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </Grid>
      </Grid>
    </Fragment>
  );
};
export default DisplayListRow;